import EstudianteService from "@/api/services/cobranza/estudiante/EstudianteService"
import Vue from "vue"

const state = () => ({
    estudiantes: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "matricula",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    ESTUDIANTES: state => {
        return state.estudiantes
    },
    ESTUDIANTES_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_ESTUDIANTES: (state, payload) => {
        state.estudiantes = payload
    },

    SET_ESTUDIANTES_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_ESTUDIANTE: (state, payload) => {
        state.estudiantes.push(payload)
    },

    UPDATE_ESTUDIANTE: (state, payload) => {
        state.estudiantes = state.estudiantes.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_ESTUDIANTE: (state, payload) => {
        state.estudiantes = state.estudiantes.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_ESTUDIANTES: async ({ commit, state }, { filter, estudianteEstado, customfilter }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }

            if (estudianteEstado === "5") {
                customfilter = `fecha_alta=${new Date().toISOString().substr(0, 10)}`
            }

            let { data, status, headers } = await EstudianteService.get({
                filter,
                estudianteEstado,
                customfilter,
                ...pagination
            })
            if (status === 200) {
                commit("SET_ESTUDIANTES", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los estudiantes, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_ESTUDIANTES: async ({ commit }) => {
        try {
            let { data, status } = await EstudianteService.get()
            if (status === 200) {
                commit("SET_ESTUDIANTES", data)
                return null
            }
        } catch (error) {
            if (error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido realizar la acción"
                })
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ESTUDIANTE_DETAILS: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstudianteService.loadDetails(payload)
            if (status === 200) {
                commit("UPDATE_ESTUDIANTE", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar los detalles del estudiante, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_RECORDS_ESTUDIANTES: async ({ commit }) => {
        try {
            let { data, status } = await EstudianteService.getAllRecords()
            if (status === 200) {
                commit("SET_ESTUDIANTES", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los estudiantes, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_ESTUDIANTE: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstudianteService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_ESTUDIANTE", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del estudiante, inténtelo nuevamente"
            })
        }
    },

    ADD_ESTUDIANTE: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstudianteService.post(payload)
            if (status === 201) {
                commit("ADD_ESTUDIANTE", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El estudiante ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el estudiante, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_ESTUDIANTE: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstudianteService.put(payload)
            if (status === 200) {
                commit("UPDATE_ESTUDIANTE", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El estudiante ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el estudiante, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_ESTUDIANTE: async ({ commit }, payload) => {
        try {
            let { status, data } = await EstudianteService.delete(payload)
            if (status === 204) {
                commit("DELETE_ESTUDIANTE", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El estudiante ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 204) {
                commit("UPDATE_ESTUDIANTE", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El estudiante ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshabilitar el estudiante, inténtelo nuevamente"
            })
        }
    },

    UPLOAD_PAGOS_FILE_ESTUDIANTES: async ({ commit }, payload) => {
        try {
            let { status } = await EstudianteService.uploadPagos(payload)
            if (status === 204) {
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El archivo de pagos ha sido cargado satisfactoriamente"
                })
                return true
            }
        } catch (error) {
            if (error.response && error.response.status === 422) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: `No se ha podido cargar el archivo de pagos, inténtelo nuevamente. ${
                        error.response.data[0].message
                    }`
                })
            } else {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: `No se ha podido cargar el archivo de pagos, inténtelo nuevamente.`
                })
            }
        }
    },

    DOWNLOAD_MODELO_PAGO_ESTUDIANTE: async ({ commit }, payload) => {
        try {
            let { data, status } = await EstudianteService.downloadModeloPago(payload)
            if (status === 200) {
                return data
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido descargar el modelo de pago para este estudiante"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
